import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { FileUpload } from "../model/domain/File";
import { PagedList } from "../model/domain/PagedList";

@Injectable({
  providedIn: "root",
})
export class FileService {
  constructor(private http: HttpClient) {}

  getFiles() {
    return this.http.get<FileUpload[]>(
      `${environment.apiUrls.files}/file-upload/files`
    );
  }

  getFilesPaginated(page: number = null, pageSize: number = null) {
    const params: any = {};
    if (page != null) {
      params.page = page;
    }

    if (pageSize != null) {
      params.pageSize = pageSize;
    }

    return this.http.get<PagedList<FileUpload>>(
      `${environment.apiUrls.files}/file-upload/list-paginated`,
      {
        params,
      }
    );
  }

  getFilesPaginatedAttachment(
    tempTicketId: any = null,
    ticketId: number,
    fileType: number = null,
    page: number = null,
    pageSize: number = null,
    group: number = null,
    structuredPrecedentId: number = null
  ) {
    const params: any = {};
    if (page != null) {
      params.page = page;
    }

    if (pageSize != null) {
      params.pageSize = pageSize;
    }

    if (group != null) {
      params.group = group;
    }

    if (ticketId != null) {
      params.ticketId = ticketId;
    }

    if (tempTicketId != null) {
      params.tempTicketId = tempTicketId;
    }

    if (fileType != null) {
      params.fileType = fileType;
    }

    if (structuredPrecedentId != null) {
      params.structuredPrecedentId = structuredPrecedentId;
    }

    return this.http.get<PagedList<FileUpload>>(
      `${environment.apiUrls.files}/file-upload/attachments`,
      {
        params,
      }
    );
  }

  getAllFilesAttachment(
    tempTicketId: any = null,
    ticketId: number,
    fileType: number = null,
    group: number = null,
    structuredSubTypeFile: number = null
  ) {
    const params: any = {};

    if (group != null) {
      params.group = group;
    }

    if (ticketId != null) {
      params.ticketId = ticketId;
    }

    if (tempTicketId != null) {
      params.tempTicketId = tempTicketId;
    }

    if (fileType != null) {
      params.fileType = fileType;
    }

    if (structuredSubTypeFile != null) {
      params.structuredSubTypeFile = structuredSubTypeFile;
    }

    return this.http.get<FileUpload[]>(
      `${environment.apiUrls.files}/file-upload/all-attachments`,
      {
        params,
      }
    );
  }

  approve(fileId: number, comments: string) {
    return this.http.post<string>(
      `${environment.apiUrls.files}/file-upload/${fileId}/approve`,
      { comments }
    );
  }

  reject(fileId: number, comments: string) {
    return this.http.post<string>(
      `${environment.apiUrls.files}/file-upload/${fileId}/reject`,
      { comments }
    );
  }

  delete(fileId: number) {
    return this.http.delete(
      `${environment.apiUrls.files}/file-upload/${fileId}/delete`
    );
  }

  download(name: string) {
    return this.http.get(
      `${environment.apiUrls.files}/file-upload/${name}/download`,
      {
        responseType: "blob",
      }
    );
  }

  uploadAttachment(file: File, tempId: any, ticketId: any = null) {
    const formData: FormData = new FormData();
    formData.append("file", file, file.name);
    formData.append("tempTicketId", tempId);
    formData.append("ticketId", ticketId);
    return this.http.post(
      `${environment.apiUrls.files}/file-upload/attachment`,
      formData
    );
  }

  newUploadAttachment(
    file: File,
    tempId: any = null,
    ticketId: any = null,
    fileTypeId: any = null,
    structuredSubTypeFile: any = null,
    structuredPrecedentId: any = null
  ) {
    const formData: FormData = new FormData();
    formData.append("file", file, file.name);
    if(tempId != null)
      formData.append("tempTicketId", tempId);
    formData.append("ticketId", ticketId);
    formData.append("fileTypeId", fileTypeId);
    formData.append("structuredSubTypeFile", structuredSubTypeFile);

    if(structuredPrecedentId != null) {
      formData.append("structuredPrecedentId", structuredPrecedentId);
    }
    
    return this.http.post<FileUpload>(
      `${environment.apiUrls.files}/file-upload/new-attachment`,
      formData
    );
  }
}
